import * as Clients from "@/enums/client";
import {GAI} from "@/enums/client";
import {
    APP_ACCOUNT_CREATE_FAILED,
    APP_ACCOUNT_CREATED,
    APP_POSTINDEX_CREATE_FAILED,
    APP_POSTINDEX_CREATED,
    APP_CHANGE_CLIENT,
    APP_INITIALIZE,
    APP_MAIL_PERFORMED,
    APP_MAIL_UNSET_POST_PACKAGE,
    APP_POST_PACKAGE_GROUP_CREATED,
    APP_POST_PACKAGE_POST_CODE_CHANGED,
    APP_MAIL_PERFORM_DELETED
} from "./actions";
import _ from "underscore"
import RegionService from "@/services/region.service"
import AreaService from "@/services/area.service"
import AuthService from "@/services/auth.service"
import PostIndexService from "@/services/post.index.service"
import Mapper from "@/mappers"
import $bus from "@/events/global.event.bus"
import * as AppEvents from "@/events/app"
import {Admin, PostOfficeAreaOperator, PostOfficeRegionAdmin, PostOfficeOperator, WebClient} from "@/enums/account.type"

export default {
    state: {
        login: null,
        regions: [],
        areas: [],
        postIndexes: [],
        clients: (() => {
            let clientKeys = Object.keys(Clients)

            return _.map(clientKeys, clientKey => {
                return Clients[clientKey]
            })
        })(),
        activeClient: (() => {
            let storageActiveClientId = localStorage.getItem("activeClient")
            if (storageActiveClientId !== null && storageActiveClientId !== undefined) {
                storageActiveClientId = +storageActiveClientId

                let clientKeys = Object.keys(Clients)
                const clients = _.map(clientKeys, clientKey => {
                    return Clients[clientKey]
                })

                const activeClient = _.find(clients, c => {
                    return c.id === storageActiveClientId
                })
                if (activeClient)
                    return activeClient;
            }
            return GAI
        })(),
        couriers: [
            "Карпова Лариса",
            "Казарина Татьяна",
            "Санчищев Алексей",
            "Пашков А",
            "Резяпкина А",
            "Юлдашев З",
            "Абдурахмонов А",
            "Исхаков"
        ],
        isInitialized: false,
        lastAction: null
    },
    getters: {
        appRegions: (state) => {
            return state.regions
        },
        appAreas: (state) => {
            return state.areas
        },
        appCouriers: (state) => {
            return state.couriers
        },
        appPostIndexes: (state) => {
            return state.postIndexes
        },
        appActiveClient: (state) => {
            return state.activeClient
        },
        appClients: (state) => {
            return state.clients
        },
        appLogin: (state) => {
            return state.login
        },

        appIsInitialized: (state) => {
            return state.isInitialized
        },
        appIsAdminLogin: state => {
            if (state.login)
                return state.login.type === Admin
            return false
        },
        appIsPostOfficeRegionLogin: state => {
            if (state.login)
                return state.login.type === PostOfficeRegionAdmin
            return false
        },
        appIsPostOfficeAreaOperator: state => {
            if (state.login)
                return state.login.type === PostOfficeAreaOperator
            return false
        },
        appIsOperatorLogin: state => {
            if (state.login)
                return state.login.type === PostOfficeOperator
            return false
        },
        appIsWebClient: state => {
            if (state.login)
                return state.login.type === WebClient
            return false
        }
    },
    mutations: {
        updateRegions(state, regions) {
            state.regions = regions
        },
        updateAreas(state, areas) {
            state.areas = areas
        },
        updatePostIndexes(state, postIndexes) {
            state.postIndexes = postIndexes
        },
        updateClient(state, client) {
            state.activeClient = client

            localStorage.setItem("activeClient", client.id)
        },
        updateLogin(state, login) {
            state.login = login
        },
        updateIsInitialized(state, isInitialized) {
            state.isInitialized = isInitialized
        },
        setLastAction(state, lastAction) {
            state.lastAction = lastAction
        }
    },
    actions: {
        [APP_INITIALIZE]: ({commit}) => {
            // region initializer
            let regionsPromise = RegionService.getAll();
            regionsPromise.then(response => {
                let regions = _.map(response.data, regionViewModel => {
                    return Mapper.mapRegion(regionViewModel)
                })

                commit("updateRegions", regions)
            })

            // area initializer
            let areasPromise = AreaService.getAll();
            areasPromise.then(response => {
                let areas = _.map(response.data, areaViewModel => {
                    return Mapper.mapArea(areaViewModel)
                })

                commit("updateAreas", areas)
            })

            // post index initializer
            let postIndexPromise = PostIndexService.getAll({});
            postIndexPromise.then(response => {
                let postIndexes = _.map(response.data, postIndexViewModel => {
                    return Mapper.mapPostIndex(postIndexViewModel)
                })

                commit("updatePostIndexes", postIndexes)
            })

            // login initializer
            let loginPromise = AuthService.getLogin()
            loginPromise.then(response => {
                let login = Mapper.mapLogin(response.data);

                commit("updateLogin", login)
            })

            Promise.all([regionsPromise, areasPromise, loginPromise])
                .then(() => {
                    commit("updateIsInitialized", true)
                    $bus.$emit(AppEvents.APP_INITIALIZE_DONE)
                })
                .catch(() => {
                    $bus.$emit(AppEvents.APP_INITIALIZE_FAILED)
                })
        },
        [APP_CHANGE_CLIENT]: ({commit}, client) => {
            commit("updateClient", client)
            $bus.$emit(AppEvents.APP_CLIENT_CHANGED, client)
        },
        [APP_MAIL_PERFORMED]: ({commit}, mail) => {
            commit("setLastAction", "Введен результат")
            $bus.$emit(AppEvents.APP_MAIL_PERFORMED, mail)
        },
        [APP_MAIL_UNSET_POST_PACKAGE]: ({commit}, {mail}) => {
            commit("setLastAction", "Досыл посьма")
            $bus.$emit(AppEvents.APP_MAIL_UNSET_POST_PACKAGE, mail)
        },
        [APP_POST_PACKAGE_POST_CODE_CHANGED]: ({commit}, payload) => {
            commit("setLastAction", "Пост индекс пост-пакета изменён")
            $bus.$emit(AppEvents.APP_POST_PACKAGE_POST_CODE_CHANGED, payload)
        },
        [APP_POST_PACKAGE_GROUP_CREATED]: ({commit}, postPackageGroup) => {
            commit("setLastAction", "Создана сводная")
            $bus.$emit(AppEvents.APP_POST_PACKAGE_GROUP_CREATED, postPackageGroup)
        },
        [APP_ACCOUNT_CREATED]: ({commit}) => {
            commit("setLastAction", "Создан новый пользователь")
            $bus.$emit(AppEvents.APP_ACCOUNT_CREATED)
        },
        [APP_ACCOUNT_CREATE_FAILED]: ({commit}) => {
            commit("setLastAction", "Ошибка при создании нового пользователя")
            $bus.$emit(AppEvents.APP_ACCOUNT_CREATE_FAILED)
        },
        [APP_POSTINDEX_CREATED]: ({commit}) => {
            commit("setLastAction", "Создан новый постиндекс")
            $bus.$emit(AppEvents.APP_POSTINDEX_CREATED)
        },
        [APP_POSTINDEX_CREATE_FAILED]: ({commit}) => {
            commit("setLastAction", "Ошибка при создании нового постиндекс")
            $bus.$emit(AppEvents.APP_POSTINDEX_CREATE_FAILED)
        },
        [APP_MAIL_PERFORM_DELETED]: ({commit}, mail) => {
            commit("setLastAction", "Статус удален")
            $bus.$emit(AppEvents.APP_MAIL_PERFORM_DELETED, mail)
        }
    }
}
